import React, { Component } from "react";
import "./EmailSignupBusiness.css"

class EmailSignupBusiness extends Component {
  constructor() {
    super();
    this.state = {
      email: ""
    };
  }

  handleEmailInput = val => {
    this.setState({ email: val });
    console.log(this.state.email);
  };

  render() {
    const { email } = this.state;

    return (
        <form
          className="business-form"
          action="https://docs.google.com/forms/u/1/d/e/1FAIpQLSf-UuTds5SU7PzeToAlZW-_-MszAJzO8bkGFII5QKvOGeefog/formResponse"
          target="_blank"
          rel="noopener noreferrer"
          method="POST"
          id="mG61Hd"
        >
          <input type="hidden" name="fvv" value="1" />
          {/* <input
            type="hidden"
            name="draftResponse"
            value='[null,null,"-5274762868312244210"]'
          /> */}
          <input type="hidden" name="pageHistory" value="0" />
          <input type="hidden" name="fbzx" value="-7539133957603159314" />
          
          <input

            className="email-input-business"
              type="email"
              jsname="YPqjbf"
              tabindex="0"
              aria-label="Email Address"
              aria-describedby="i.desc.1672297179 i.err.1672297179"
              name="entry.103811996"
              value={email}
              onChange={evt => this.handleEmailInput(evt.target.value)}
              placeholder="Company Email"
            />
            <button
              type="submit"
              className="business-signup-button"
            >
              Join the waitlist
            </button>
          </form>
    );
  }
}

export default EmailSignupBusiness;
